var React = require('react');

function ExpandDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M.44 12.44a1.5 1.5 0 012.12 0L24 33.876l21.44-21.438a1.5 1.5 0 112.12 2.122L26.123 35.997a2.998 2.998 0 01-4.24.004L.438 14.56a1.5 1.5 0 010-2.122zM24 33.876zm0 0z"}));
}

ExpandDown.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ExpandDown;

ExpandDown.default = ExpandDown;
